/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryItemEditViewGeneralController(this: JS5Object, _: JS5Object,
                                               $routeParams: JS5Object) {
    const setVisibleFormControls = (type: string) => {
        switch (type) {
            case 'Video':
                this.visibleFormControls = {
                    type: true,
                    name: true,
                    deliveryConditionTemplate: true,
                    ccRequiredForDelivery: true
                };
                break;
            case 'Audio':
            case 'Image':
            case 'Artwork':
            case 'CC':
            case 'Subtitle':
                this.visibleFormControls = {
                    type: true,
                    name: true,
                    deliveryConditionTemplate: true,
                    requiredForDelivery: true
                };
                break;
            case 'Metadata':
                this.visibleFormControls = {
                    type: true,
                    name: true,
                    deliveryConditionTemplate: true,
                    requiredForDelivery: true,
                    includeMd5Values: true,
                    byteOrderMark: true,
                    embargoManifestFlag: true
                };
                break;
            case 'Archive':
                this.visibleFormControls = {
                    type: true,
                    name: true
                };
                break;
            default :
                this.visibleFormControls = null;
                console.warn(`Unknown delivery item type [${this.editData.type}] when setting visibly form controls `);
                break;
        }
    };

    this.handleDeliveryConditionTemplateChange = () => {
        if (this.deliveryConditions != null) {
            this.editData.deliveryConditions = [this.deliveryConditions]
        } else {
            this.editData.deliveryConditions = [];
        }
    };

    const setDeliveryConditions = () => {
        if (_.size(this.editData.deliveryConditions)) {
            this.deliveryConditions = _.first(this.editData.deliveryConditions)
        } else {
            this.deliveryConditions = null;
        }
    };

    this.$onInit = () => {
        setVisibleFormControls($routeParams.deliveryItemType);
        setDeliveryConditions();
    };

    this.$onChanges = () => {
        setDeliveryConditions();
    };
}

angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewGeneral', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/general/delivery-items-edit-view-general-template.html',
    controller: DeliveryItemEditViewGeneralController,
    bindings: {
        editData: '<',
        conditionalTemplates: '<'
    }
});



